import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
  Alpine.data('personSelector', (url) => ({
    people: [],
    filtered: [],
    display: '',
    selectedId: null,
    showSuggestions: false,

    async init() {
      const res = await fetch(url);
      const rawData = await res.json();

      const headers = rawData.data[0];
      const idCol = headers.indexOf('id');
      const nameCol = headers.indexOf('name');

      this.people = rawData.data
        .slice(1 + rawData.skipRows)
        .map((val) => ({
          id: val[idCol],
          name: val[nameCol],
        }));
    },

    onInput() {
      this.showSuggestions = true;
      const q = this.display.toLowerCase();

      this.filtered = this.people.filter((p) =>
        (`${p.id} - ${p.name}`).toLowerCase().includes(q)
      );

      const match = this.people.find(
        (p) => `${p.id} - ${p.name}` === this.display
      );

      if (!match) this.selectedId = null;
    },

    selectPerson(person) {
      this.display = `${person.id} - ${person.name}`;
      this.selectedId = `${person.id} - ${person.name}`;
      // Notify parent of selection
      this.$dispatch('person-selected', `${person.id} - ${person.name}`);
      this.showSuggestions = false;
    },

    onBlur() {
      setTimeout(() => {
        const match = this.people.find(
          (p) => `${p.id} - ${p.name}` === this.display
        );
        if (!match) {
          this.display = '';
          this.selectedId = null;
          this.$dispatch('person-selected', null);
        }
        this.showSuggestions = false;
      }, 100);
    }
  }));
});
